import { t } from '@/plugins/i18n'
export const fundColumns: any = [
  {
    label: t('出账 / 入账') + '(元)',
    prop: 'changeAmount',
    align: 'center',
    slotName: 'changeAmount'
  },
  {
    label: t('余额') + '(元)',
    prop: 'afterAvailableAmount',
    align: 'center'
  },
  {
    label: t('费用类型'),
    prop: 'fundFlowType',
    align: 'center',
    slotName: 'fundFlowType'
  },
  {
    label: t('明细'),
    prop: 'bizContentCustomer',
    align: 'center',
    width: 300,
    slotName: 'bizContentCustomer'
  },
  {
    label: t('流水号'),
    prop: 'fundFlowNo',
    align: 'center'
  },
  {
    label: t('日期'),
    prop: 'updateTime',
    align: 'center',
    slotName: 'updateTime'
  }
]

export const subFundColumns: any = [
  {
    label: t('出账 / 入账') + '(元)',
    prop: 'changeAmount',
    align: 'center',
    slotName: 'changeAmount'
  },
  {
    label: t('可用余额') + '(元)',
    prop: 'afterAvailableAmount',
    align: 'center'
  },
  {
    label: t('费用类型'),
    prop: 'fundFlowType',
    align: 'center',
    slotName: 'fundFlowType'
  },
  {
    label: t('明细'),
    prop: 'bizContentCustomer',
    align: 'center',
    width: 300,
    slotName: 'bizContentCustomer'
  },
  {
    label: t('直行便订单编号'),
    prop: 'orderNo',
    align: 'center',
    width: 230,
    slotName: 'orderNo'
  },
  // {
  //   label: t('订单标题'),
  //   prop: 'orderTitle',
  //   align: 'center',
  //   width: 150
  // },
  {
    label: t('直行便发货单号'),
    prop: 'deliverOrderNo',
    align: 'center',
    width: 230,
    slotName: 'deliverOrderNo'
  },
  // {
  //   label: t('发货标题'),
  //   prop: 'deliverTitle',
  //   align: 'center',
  //   width: 150
  // },
  {
    label: t('流水号'),
    prop: 'fundFlowNo',
    align: 'center'
  },
  {
    label: t('日期'),
    prop: 'updateTime',
    align: 'center',
    slotName: 'updateTime'
  }
]

export const tableConfig = {
  showHandler: true,
  handlerConfig: { minWidth: 120, fixed: false },
  setHeight: true
}

export const changeTypeDict = {
  1: t('出账'),
  2: t('入账')
}

export const formatPrice = (price: any) => String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
export const plusPrice = (price: any) => price ? '+' + price : 0
export const reducePrice = (price: any) => price ? '-' + price : 0
export const platformOrderItemSettleTypeDict: any = {
  1: t('冻结'),
  2: t('解冻'),
  3: t('结算'),
  4: t('重拍冻结')
}

export const setFixed2 = (total: any) => {
  return total > 0 ? Number(total.toFixed(2)) : 0
}

export const historyColumns = [
  { prop: 'fundFlowNo', label: t('流水号') },
  {
    prop: 'balanceRechargeStatus',
    label: t('状态'),
    slotName: 'balanceRechargeStatus'
  },
  {
    prop: 'remittanceAmount',
    label: t('存入金额'),
    slotName: 'remittanceAmount'
  },
  {
    prop: 'payChannel',
    label: t('明细'),
    slotName: 'payChannel'
  },
  { prop: 'refuseReason', label: t('拒绝原因') },
  {
    prop: 'createTime',
    label: t('日期'),
    width: 200,
    slotName: 'createTime'
  }
]

export const secondFlowType = {
  // 余额充值
  1: [
    {
      name: 'paypal',
      value: ''
    },
    {
      name: 'payoneer',
      value: ''
    },
    {
      name: '銀行振込',
      value: ''
    }
  ],
  // // 提现
  // 2: [
  //   {
  //     name: '銀行振込',
  //     value: ''
  //   }
  // ],
  // // 提现失败
  // 21: [
  //   {
  //     name: '銀行振込',
  //     value: ''
  //   }
  // ],
  // 转入 店铺
  10: [],
  // 转出 店铺
  11: [],
  // 会员费 会员类型
  12: [],
  // 手续费
  6: [
    {
      name: 'OEM見積もり依頼'
    },
    {
      name: '既製品仕入れ'
    },
    {
      name: '市場商品仕入れ'
    },
    {
      name: '不良品返品'
    },
    {
      name: '不良品再購入'
    },
    {
      name: 'OEM量産'
    },
    {
      name: 'OEMサンプル発注'
    },
    {
      name: '商品組み合わせ'
    },
    {
      name: '保管料'
    },
    {
      name: '入庫作業'
    },
    {
      name: '出荷作業'
    }
  ],
  // 商品附加项
  15: [
    {
      name: '洗濯タグ作成'
    },
    {
      name: '詳細検品（表のみ）'
    },
    {
      name: '詳細検品（表＋裏側）'
    },
    {
      name: 'ボタンホール開け'
    },
    {
      name: '布タグ縫い付け'
    },
    {
      name: '洗濯タグ縫い付け'
    },
    {
      name: '元タグ取り外し（洗濯タグ、布タグ、吊り札）'
    },
    {
      name: 'アクセサリー用台紙付け替え'
    },
    {
      name: '検針作業'
    },
    {
      name: 'アイロンがけ'
    },
    {
      name: '脱臭作業'
    },
    {
      name: 'サンクスカード入れ（検品際に各商品に入れ）'
    },
    {
      name: 'リボン包装（検品際に各商品に入れ）'
    },
    {
      name: '薄葉紙包装（検品際に各商品に入れ）'
    },
    {
      name: '吊り札掛け'
    },
    {
      name: '通電検査'
    },
    {
      name: 'スクラッチカード入れ（検品際に各商品に入れ）'
    },
    {
      name: 'クーポンカート入れ（検品際に各商品に入れ）'
    },
    {
      name: '保証カート入れ（検品際に各商品に入れ）'
    },
    {
      name: '取扱説明書入れ'
    },
    {
      name: '（普通OPP袋）替え'
    },
    {
      name: '（自社ブランドOPP袋）替え'
    },
    {
      name: '特殊収納袋替え'
    },
    {
      name: '他の付属品入れ（検品際に各商品に入れ）'
    },
    {
      name: '商品採寸'
    },
    {
      name: 'プチプチ梱包'
    },
    {
      name: 'ストレッチフィルム梱包'
    },
    {
      name: 'クッション梱包'
    },
    {
      name: '吊り札掛け（糸ロックス）'
    },
    {
      name: '元タグ取り外し'
    },
    {
      name: '布タグ取り外し'
    },
    {
      name: '洗濯タグ取り外し'
    },
    {
      name: '吊り札取り外し'
    },
    {
      name: 'サイズ変更（サイズタグ縫い付け）'
    },
    {
      name: 'サイズ変更（サイズシール表記）'
    },
    {
      name: 'ゆるい検品（表のみ）'
    },
    {
      name: '圧縮袋梱包'
    }

  ],
  16: [
    {
      name: 'サンクスカード入れ（梱包際に各パッケージに入れ）'
    },
    {
      name: 'リボン包装（梱包際に各パッケージに入れ）'
    },
    {
      name: '段ボール外箱'
    },
    {
      name: '段ボール梱包作業'
    },
    {
      name: 'プチプチ梱包'
    },
    {
      name: 'Amazonラベル貼る'
    },
    {
      name: 'パレット梱包'
    },
    {
      name: '薄葉紙包装（梱包際に各パッケージに入れ）'
    },
    {
      name: 'スクラッチカード入れ（梱包際に各パッケージに入れ）'
    },
    {
      name: 'クーポンカート入れ（梱包際に各パッケージに入れ）'
    },
    {
      name: '保証カート入れ（梱包際に各パッケージに入れ）'
    },
    {
      name: '他の付属品入れ（梱包際に各パッケージに入れ）'
    },
    {
      name: '普通発送袋'
    },
    {
      name: '自社ブランド発送袋'
    },
    {
      name: '木枠梱包'
    },
    {
      name: '箱ラベル'
    }
  ],
  // 次转正
  27: [
    {
      name: '洗濯タグ作成'
    },
    {
      name: '詳細検品（表のみ）'
    },
    {
      name: '詳細検品（表＋裏側）'
    },
    {
      name: 'ボタンホール開け'
    },
    {
      name: '布タグ縫い付け'
    },
    {
      name: '洗濯タグ縫い付け'
    },
    {
      name: '元タグ取り外し（洗濯タグ、布タグ、吊り札）'
    },
    {
      name: 'アクセサリー用台紙付け替え'
    },
    {
      name: '検針作業'
    },
    {
      name: 'アイロンがけ'
    },
    {
      name: '脱臭作業'
    },
    {
      name: 'サンクスカード入れ（検品際に各商品に入れ）'
    },
    {
      name: 'リボン包装（検品際に各商品に入れ）'
    },
    {
      name: '薄葉紙包装（検品際に各商品に入れ）'
    },
    {
      name: '吊り札掛け'
    },
    {
      name: '通電検査'
    },
    {
      name: 'スクラッチカード入れ（検品際に各商品に入れ）'
    },
    {
      name: 'クーポンカート入れ（検品際に各商品に入れ）'
    },
    {
      name: '保証カート入れ（検品際に各商品に入れ）'
    },
    {
      name: '取扱説明書入れ'
    },
    {
      name: '（普通OPP袋）替え'
    },
    {
      name: '（自社ブランドOPP袋）替え'
    },
    {
      name: '特殊収納袋替え'
    },
    {
      name: '他の付属品入れ（検品際に各商品に入れ）'
    },
    {
      name: '商品採寸'
    },
    {
      name: 'プチプチ梱包'
    },
    {
      name: 'ストレッチフィルム梱包'
    },
    {
      name: 'クッション梱包'
    },
    {
      name: '吊り札掛け（糸ロックス）'
    },
    {
      name: '元タグ取り外し'
    },
    {
      name: '布タグ取り外し'
    },
    {
      name: '洗濯タグ取り外し'
    },
    {
      name: '吊り札取り外し'
    },
    {
      name: 'サイズ変更（サイズタグ縫い付け）'
    },
    {
      name: 'サイズ変更（サイズシール表記）'
    },
    {
      name: 'ゆるい検品（表のみ）'
    },
    {
      name: '圧縮袋梱包'
    }

  ]
}
